import React, { FunctionComponent } from 'react';
import type { Props } from './types';
import classnames from 'classnames';

const PAGINATE_PER = 20;

export const Presentation: FunctionComponent<Props> = ({
  recruitmentsCount,
  page,
  isPc,
  sort,
  dataCategory,
  dataValue,
  handleFetchSort,
}) => {
  return (
    <nav className="articles-tab articles-tab--sb">
      <div className="articles-tab-count">
        <span>
          {recruitmentsCount > page * PAGINATE_PER ? page * PAGINATE_PER : recruitmentsCount} / <span className="articles-tab-count-text">{recruitmentsCount}</span>
        </span>
      </div>
      {isPc && (
        <ul className="articles-tab-list-recruitments gtm-sort-view-count" data-event-name='sort on screen' data-category={dataCategory} data-value={dataValue.recruitmentsSort}>
          <li
            onClick={handleFetchSort}
            data-event="click"
            data-category={dataCategory}
            data-value={dataValue.popular}
            className={classnames('articles-tab-item', { 'is-current': sort === 'popular' })}
          >
            <a>人気順</a>
          </li>
          <li
            onClick={handleFetchSort}
            data-event="click"
            data-category={dataCategory}
            data-value={dataValue.new}
            className={classnames('articles-tab-item', { 'is-current': sort !== 'popular' })}
          >
            <a>新着順</a>
          </li>
        </ul>
      )}
      {!isPc && (
        <div className="articles-tab-list-sp articles-tab-list-sp--show">
          <ul className="articles-tab-list-sp-inner gtm-sort-view-count" data-event-name='sort on screen' data-category={dataCategory} data-value={dataValue.recruitmentsSort}>
            <li
              onClick={handleFetchSort}
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue.popular}
              className={classnames('articles-tab-list-sp-inner-item', { 'is-current': sort === 'popular' })}
            >
              <a>人気順</a>
            </li>
            <li
              onClick={handleFetchSort}
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue.new}
              className={classnames('articles-tab-list-sp-inner-item', { 'is-current': sort !== 'popular' })}
            >
              <a>新着順</a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};
